<template>
  <div class="settings">
    <h1 class="title">Administration</h1>
    <div class="box has-background-light">
      <nav class="level">
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Total Users</p>
            <p class="title"><span :class="{ 'loader': !totalUsers }"></span> <span v-if="totalUsers">{{totalUsers}}</span></p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Total Companies</p>
            <p class="title"><span :class="{ 'loader': !totalCompanies }"></span> <span v-if="totalCompanies">{{totalCompanies}}</span></p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Total Roof Models</p>
            <p class="title"><span :class="{ 'loader': !totalModels }"></span> <span v-if="totalModels">{{totalModels}}</span></p>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalUsers: 0,
      totalCompanies: 0,
      totalModels: 0,
    };
  },

  mounted() {
    this.fetchStats();
  },

  methods: {
    fetchStats() {
      const urls = [
        '/api/user/list',
        '/api/company/list',
        '/api/roof/list',
      ];

      Promise.all(urls.map(url =>
        fetch(url).then(res => res.json()))).then((data) => {
        this.totalUsers = data[0].users.length;
        this.totalCompanies = data[1].companies.length;
        this.totalModels = data[2].roofs.length;
      });
    },
  },
};
</script>
